import { getItemsArray } from '../../../util/prop_utils'
import { tagsToOptions } from '../tag_select'

/** Persist tag row state when closing the new-entry modal (IDs only for saved tags). */
function serializeTagsForDraft(tags) {
    if (!tags || !tags.length) return []
    return tags.map(t => {
        if (t.id) return { id: t.id }
        return { name: t.name, color: t.color, teamId: t.teamId }
    })
}

/** Rebuild TagSelect values from a draft snapshot (after tag map updates). */
function deserializeTagsFromDraft(snapshot, tagMap, teams) {
    if (!snapshot) return []
    return snapshot
        .map(s => {
            if (s.id != null && tagMap[s.id]) {
                return tagsToOptions([tagMap[s.id]], teams)[0]
            }
            if (s.name) {
                const raw = {
                    name: s.name,
                    color: s.color,
                    teamId: s.teamId,
                }
                return tagsToOptions([raw], teams)[0]
            }
            return null
        })
        .filter(Boolean)
}

function filterTagsByTeam(tags, teamId, personalTeamId) {
    if (!teamId && teamId !== 0) return tags
    return tags.filter(tag => tag.teamId === teamId || tag.teamId === personalTeamId)
}

function getFirstTeamTag(tags, personalTeamId) {
    return tags.find(tag => !!tag.teamId && tag.teamId !== personalTeamId) || {}
}

const getFirstExpiredTeam = (tags, teams, personalTeamId) => {
    // get the tag
    const t =
        tags.find(tag => {
            const team = teams[tag.teamId]
            return (
                !!tag.teamId &&
                tag.teamId !== personalTeamId &&
                team.trialEnd &&
                new Date(team.trialEnd) < new Date()
            )
        }) || null
    // return the team or null
    return (t && teams[t.teamId]) || null
}

function getFilteredTagsArray(sourceTags, selectedTags=[], personalTeamId) {
    const tagArray = getItemsArray(sourceTags)
    const teamTag = getFirstTeamTag(selectedTags, personalTeamId)
    return filterTagsByTeam(tagArray, teamTag.teamId, personalTeamId)
}

function getTagsAsOptions(ids, tagMap, teams) {
    const tagArr = ids.map(id => tagMap[id])
    return tagsToOptions(tagArr, teams)
}

export {
    deserializeTagsFromDraft,
    getFilteredTagsArray,
    getFirstExpiredTeam,
    getFirstTeamTag,
    getTagsAsOptions,
    serializeTagsForDraft,
}



// WEBPACK FOOTER //
// ./src/common/components/modals/time_entry_modal.js